<script setup>
const props = defineProps({
  searchTerm: String,
  page: Number,
  metaData: Object,
  locations: Array,
  settings: Object
})
const totalPages = props.metaData ? props.metaData.pagination.pageCount : 0;

let definedMatches = [];
if (props.settings) {
  props.settings.definedMatches.forEach((match) => {
    const keywords = match.searchWords.split(',');
    keywords.forEach((keyword) => {
      if (props.searchTerm.toLowerCase().includes(keyword)) {
        definedMatches = match.locations;
      }
    })
  })
}


</script>
<template>
  <div class="block location-search-results">
    <div class="container">
      <div class="locations-search-head">
        <div class="row justify-content-between">
            <div class="locations-result col-sm-9" v-if="locations.length > 0 || definedMatches.length > 0">
              <h2>{{ settings.resultsReturnedTitle }}</h2>
              <div class="location-blurb" v-if="settings.resultsAdditionalMessage">
                <div v-html="settings.resultsAdditionalMessage"></div>
              </div>
            </div>
            <div class="pagination top col-sm-3 " v-if="totalPages > 1">                
              <LocationSearchPagination :page="page" :totalPages="totalPages" :searchTerm="searchTerm" />
            </div>
        </div>
        <template v-for="(location, index) in definedMatches" :key="location.id" v-if="page == 1">
          <LocationRowResult :location="location" />
          <hr v-if="index < definedMatches.length - 1">
        </template>
        <div class="locations-result col-12" v-if="locations.length == 0">
          <div class="no-results" v-if="settings.noResultsAvailable" >
            <div v-html="settings.noResultsAvailable"></div>
          </div>
          <div class="location-blurb" v-if="settings.resultsAdditionalMessage">
            <div v-html="settings.resultsAdditionalMessage"></div>
          </div>
        </div>

      </div>

      <div class="row mb-4" v-if="locations.length > 0">
        <div class="col-12">
          <p class="py-3 mb-0">Showing locations within 250 miles of <strong>{{ searchTerm }}</strong>.</p>
          <hr>
        </div>
      </div>
      
      <template v-for="(location, index) in locations" :key="location.id">
        <LocationRowResult :location="location" />
        <hr v-if="index < locations.length - 1">
      </template>

      <div class="row justify-content-between mt-3" v-if="totalPages > 1">
        <div class="pagination offset-sm-9 col-sm-3 " >                
          <LocationSearchPagination :page="page" :totalPages="totalPages" :searchTerm="searchTerm" />
        </div>
      </div>
    </div>

  </div>
</template>

<style lang="scss">
.location-search-results {
  margin: 40px 0px;

  @include media-breakpoint-up(md) {
    margin: 80px 0px;        
  }

  .location {
    .location-image {
      margin-bottom: 15px;
      overflow: hidden;

      @include media-breakpoint-up(md) {
        margin-bottom: 0px;        
      }

      img {
        width: 100%;
      }
    }

    .location-name {
      font-weight: bold;
      text-decoration: underline;
      font-size: 1.25rem;
      color: $color-primary;
      margin: 0;
      display: inline;
    }

    .location-distance {
      text-align: right;
      color: $color-primary;
    }

    .location-address {
      text-align: left;
      color: #9a9a9a;
      margin: 0;
      font-size: inherit;
      font-weight: 700;
    }

    .location-status {
      font-size: 0.875em;
      line-height: 25px;
      letter-spacing: -0.12px;
      &--open {
        color: #30ad3e;
      }
      &--coming-soon {
        color: #aa9314;
      }
      &--waitlist {
        color: #ad307d;
      }
    }

    ul {
      padding-left: 19px;

      .info-line {
        color: $color-primary;
        margin-left: -5px;    
      }
    }


  }

  .locations-search-head {
    margin: 0 auto 40px;
    position: relative;

    .locations-result {
      h2 {
        letter-spacing: 0.4px;
        text-align: left;
        color: $color-black;
        font-weight: bold;
        margin-top: 0;
      }
      h3 {
        color: $color-black;
        font-weight: bold;
        line-height: 1.6;
      }
    }
  }

  .pagination {
    &.top {
      @include media-breakpoint-down(xs) {
        margin-bottom: 15px;        
      }
    }

    ul {
      list-style-type: none;
      text-align: right;
      margin: 0 auto;
      padding: 0;
      

      li {
        display: inline-block;
        text-align: center;
        border-radius: 15px;
        cursor: pointer;
        margin: 0 5px;
        width: 30px;

        a {
          padding: 2px 10px;
          display: block;
          text-align: center;
          color: black;
          font-weight: bold;
          text-decoration: none;
        }

        &.disabled {
          cursor: default;

          a {
            color: #C0C0C0;
          }
        }

        &.page-left {
          transform: rotate(180deg);
        }

        &:hover:not(.page-left):not(.page-right):not(.disabled):not(.current-page) {
          background-color: #DEDEDE;
        }

        &.current-page {
          background-color: $color-id-green;

          a {
            color: white;
          }
        }
      }
    }
  }
}
</style>